module.exports = __webpack_public_path__ + "img/illustration.62f39b6c.svg";